import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

interface RelatedArticlesProps {
  currentId: number;
  category: string;
}

export default function RelatedArticles({ currentId, category }: RelatedArticlesProps) {
  const related = articles
    .filter((a) => a.id !== currentId && a.categorySlug === category)
    .slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        {/* Title */}
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          相关大瓜推荐
        </h2>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {related.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-background-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {article.isHot && (
                  <div className="absolute top-3 left-3 flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    <i className="ri-fire-line text-xs"></i>
                    <span>热门</span>
                  </div>
                )}
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-bold text-foreground-950 text-base leading-snug mb-3 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between text-foreground-400 text-xs">
                  <span>{article.category}</span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}